/** 샵관리 화면 공통 헬퍼 (조회조건 필드, 필터, 컬럼 잠금) */
import { CommonCss } from 'styles/common.styles';
import { SEARCH_LABEL_W } from 'styles/theme';
import { YN_OPTIONS } from 'shop/shopStore';

export const kwField = (placeholder = '검색어') => ({
  name: 'keyword',
  label: '검색어',
  width: CommonCss.w160,
  labelWidth: SEARCH_LABEL_W,
  placeholder,
});

export const ynField = () => ({
  name: 'useYn',
  label: '사용',
  type: 'select',
  width: CommonCss.w80,
  labelWidth: SEARCH_LABEL_W,
  options: [{ value: '', label: '전체' }, ...YN_OPTIONS],
});

export const selectField = (name, label, options, width = CommonCss.w120) => ({
  name,
  label,
  type: 'select',
  width,
  labelWidth: SEARCH_LABEL_W,
  options: [{ value: '', label: '전체' }, ...options],
});

export const dateRangeFields = () => [
  { name: 'fromDate', label: '기간', type: 'date', width: CommonCss.w120, labelWidth: SEARCH_LABEL_W },
  { name: 'toDate', label: '~', type: 'date', width: CommonCss.w120, labelWidth: '20px' },
];

export function matchKeyword(row, fields, keyword) {
  const kw = String(keyword || '').trim().toLowerCase();
  if (!kw) return true;
  return fields.map((f) => String(row?.[f] ?? '').toLowerCase()).join(' ').includes(kw);
}

/** 기간 필터 (yyyy-MM-dd 문자열 비교, 시각이 붙어 있어도 앞 10자리만 본다) */
export function inRange(dateStr, from, to) {
  const d = String(dateStr || '').slice(0, 10);
  if (from && d < from) return false;
  if (to && d > to) return false;
  return true;
}

/** 이미 저장된 행(mod !== 'A')은 수정 못 하게 잠근다 */
export const lockExisting = (col) => ({ ...col, meta: { ...col.meta, editable: (row) => row?.mod === 'A' } });

export const clearMod = (rows) => rows.map((r) => ({ ...r, mod: '' }));

/** 중복 검사 — 삭제행 제외 */
export function dupErrors(rows, field, name) {
  const seen = new Set();
  const errors = [];
  for (const r of rows) {
    if (r.mod === 'D') continue;
    const v = String(r[field] || '').trim().toUpperCase();
    if (!v) continue;
    if (seen.has(v)) errors.push(`${name} 중복: ${r[field]}`);
    seen.add(v);
  }
  return errors;
}
